// extracted by mini-css-extract-plugin
module.exports = {"page":"chapter-list-page_page__2r_Wu","chapter":"chapter-list-page_chapter__2cxN6"};